export enum IDocumentTypeId {
  INVOICE_DOCUMENT = 1,
  BULKS_DOCUMENT = 4,
  CSF = 5,
  RPC = 6,
  FIEL = 7,
  LEGAL_REPRESENTATIVE_GRANTED = 8,
  LEGAL_REPRESENTATIVE_DNI = 9,
  PROOF_OF_ADDRESS = 10,
  CONSTITUTiVE_FILE = 11,
  BANK_STATEMENT = 12,
  CHAMBER_OF_COMMERCE = 13,
  PERSONAL_IDENTIFICATION = 14,
  PERSONAL_IDENTIFICATION_BACK = 15,
  COMPANY_OPERATION = 21,
  BUSINESS_NATURE = 22,
}

export enum IDocumentUsaTypeId {
  PERSONAL_ID = 14,
  PERSONAL_ID_BACK = 15,
  PASSPORT = 16,
  DRIVERS_LICENCE = 19,
  DRIVERS_LICENCE_BACK = 20,
  EIN_DOCUMENT = 24,
}

export enum OnboardingDocumentTypeIds {
  csf = IDocumentTypeId.CSF,
  rpc = IDocumentTypeId.RPC,
  fiel = IDocumentTypeId.FIEL,
  legalRepresentativeGranted = IDocumentTypeId.LEGAL_REPRESENTATIVE_GRANTED,
  legalRepresentativeDni = IDocumentTypeId.LEGAL_REPRESENTATIVE_DNI,
  proofOfAddress = IDocumentTypeId.PROOF_OF_ADDRESS,
  constitutionFile = IDocumentTypeId.CONSTITUTiVE_FILE,
  bankStatement = IDocumentTypeId.BANK_STATEMENT,
  chamberOfCommerce = IDocumentTypeId.CHAMBER_OF_COMMERCE,
  personalIdentification = IDocumentTypeId.PERSONAL_IDENTIFICATION,
  personalIdentificationBack = IDocumentTypeId.PERSONAL_IDENTIFICATION_BACK,
  businessNature = IDocumentTypeId.BUSINESS_NATURE,
  companyOperation = IDocumentTypeId.COMPANY_OPERATION,
  einDocument = IDocumentUsaTypeId.EIN_DOCUMENT,
}

export enum OnboardingUsaDocumentTypeIds {
  passport = IDocumentUsaTypeId.PASSPORT,
  personalId = IDocumentUsaTypeId.PERSONAL_ID,
  personalIdBack = IDocumentUsaTypeId.PERSONAL_ID_BACK,
  driversLicence = IDocumentUsaTypeId.DRIVERS_LICENCE,
  driversLicenceBack = IDocumentUsaTypeId.DRIVERS_LICENCE_BACK,
}

export const FORM_INITIAL_BULK_UPLOAD: IUploadBulksDocuments = {
  documentTypeId: 4,
  totalDocuments: 0,
  documents: undefined,
};
export interface IUploadDocuments {
  documentTypeId: IDocumentTypeId;
  totalDocuments: number;
  documents: FormData | undefined;
}

export interface IUploadOnboardingDocuments {
  documentTypeId: OnboardingDocumentTypeIds | OnboardingUsaDocumentTypeIds;
  totalDocuments: number;
  documents: FormData | undefined;
}

export interface IUploadBulksDocuments {
  documentTypeId: IDocumentTypeId;
  totalDocuments: number;
  documents: FormData | undefined;
  bulksDocument?: File;
}

export interface BulkDocumentResponse {
  id: number;
  document: string;
  rate: string;
  created_at: string;
  url?: string;
  status: string;
}
